import { defaultPlaceholder } from "./defaultPlaceholder";
import { sucursalDeptoForSector } from "./sucursalDeptoForSector";

export const retriveSucursalDeptoData = (motivos, formik) => {
  let result = [[], "Sucursal / Departamento", defaultPlaceholder(formik)];

  const sucursalDepartamento = sucursalDeptoForSector(motivos, formik)
    .map((sucDepto) => {
      return { label: sucDepto.titulo || sucDepto.title, value: sucDepto.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  if (formik.values.asignacion2 === 1) {
    result = [sucursalDepartamento, "Departamento", "Seleccione el departamento"];
  }
  if (formik.values.asignacion2 === 2) {
    result = [sucursalDepartamento, "Sucursal", "Seleccione la sucursal"];
  }

  let value = result[0].find((option) => {
    return option.value === formik.values.sucursaldepartamentoAsignado;
  });
  value = value || null;
  result.push(value);

  if ((value && value.value) !== formik.values.sucursaldepartamentoAsignado) {
    formik.setFieldValue("sucursaldepartamentoAsignado", value && value.value);
  }

  return result;
};
